
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Aviso-de-privacidad",
      function () {
        return require("private-next-pages/Aviso-de-privacidad/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Aviso-de-privacidad"])
      });
    }
  